import React, { useEffect, useMemo, useState } from "react";
import { FiCheck } from "react-icons/fi";
import BottomSheet from "./BottomSheet";
import "./ListPickerSheet.css";

export default function ListPickerSheet({
  open,
  onClose,
  title,
  value,
  options = [],
  optionsKey = "",
  onSelect,
  searchable = false,
  searchPlaceholder = "Search",
  emptyLabel = "No results",
}) {
  const [query, setQuery] = useState("");

  useEffect(() => {
    if (!open) setQuery("");
  }, [open]);

  useEffect(() => {
    setQuery("");
  }, [optionsKey]);

  const filteredOptions = useMemo(() => {
    const trimmed = query.trim().toLowerCase();
    if (!searchable || !trimmed) return options;
    return options.filter((option) => String(option).toLowerCase().includes(trimmed));
  }, [options, query, searchable]);

  const handleSelect = (option) => {
    onSelect?.(option);
    onClose?.();
  };

  return (
    <BottomSheet open={open} onClose={onClose} title={title}>
      {searchable ? (
        <div className="list-picker-sheet__search-wrap">
          <input
            type="search"
            className="list-picker-sheet__search"
            value={query}
            onChange={(event) => setQuery(event.target.value)}
            placeholder={searchPlaceholder}
            autoComplete="off"
          />
        </div>
      ) : null}

      <ul className="list-picker-sheet__list" role="listbox" aria-label={title}>
        {filteredOptions.length === 0 ? (
          <li className="list-picker-sheet__empty">{emptyLabel}</li>
        ) : (
          filteredOptions.map((option) => {
            const selected = option === value;
            return (
              <li key={option} role="presentation">
                <button
                  type="button"
                  role="option"
                  aria-selected={selected}
                  className={`list-picker-sheet__option${selected ? " list-picker-sheet__option--selected" : ""}`}
                  onClick={() => handleSelect(option)}
                >
                  <span>{option}</span>
                  {selected ? <FiCheck aria-hidden /> : null}
                </button>
              </li>
            );
          })
        )}
      </ul>
    </BottomSheet>
  );
}
